module.exports = __webpack_public_path__ + "static/media/landing_image.c87d0eb8.jpeg";